module.exports = __webpack_public_path__ + "img/2.441695ad.webp";